import React from 'react';
import styled from '@emotion/styled';

const Wrapper = styled('tr')`
  height: 103px;

  td {
    padding: 0.85rem;
  }

  .td {
    width: 200px;
  }

  .skelet {
    background-color: #f2f5f7;
    border-radius: 0.25rem;
    -webkit-animation: blinking 1s infinite ease-in-out;
    animation: blinking 1s infinite ease-in-out;
    @media (max-width: 731px) {
      margin-top: 5px;
    }
  }

  .checkbox {
    width: 17px;
    height: 17px;
  }

  .text {
    height: 10px;
    &:nth-child(n + 2) {
      margin-top: 10px;
    }
  }

  .title {
    &--top {
      width: 50%;
    }
    &--mid {
      width: 60%;
    }
    &--bottom {
      width: 100%;
    }
  }

  .customer {
    &--bottom {
      width: 70%;
    }
  }

  .status-wrap {
    display: flex;
    align-items: center;
    .dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }
    .line {
      width: 34px;
      height: 4px;
      border-radius: 0;
    }
    .text {
      width: 120px;
    }
  }

  .status-text {
    width: 125px;
  }

  .delivery-logo {
    height: 15px;
    width: 40%;
  }

  .delivery-text {
    width: 60%;
    margin-top: 20px !important;
  }

  .city {
    width: 50%;
    margin-top: -8px;
  }

  .region {
    width: 30%;
  }

  .delivery-status {
    width: 50%;
  }

  .price {
    width: 30%;
  }

  @media (max-width: 731px) {
    .display-desktop-only {
      width: 23px;
      display: none;
    }
  }
`;

const OrdersSkeleton = () => {
  return (
    <Wrapper>
      <td style={{ width: '50px' }} className="checkbox-wrap display-desktop-only">
        <div className="checkbox skelet"></div>
      </td>
      <td className="td">
        <div className="text title--top skelet"></div>
        <div className="text title--mid skelet"></div>
        <div className="text title--bottom skelet"></div>
      </td>
      <td className="td">
        <div className="text skelet"></div>
        <div className="text customer--bottom skelet"></div>
      </td>
      <td className="td display-desktop-only">
        <div className="status-wrap">
          <div className="dot skelet"></div>
          <div className="line skelet"></div>
          <div className="dot skelet"></div>
          <div className="line skelet"></div>
          <div className="dot skelet"></div>
          <div className="line skelet"></div>
          <div className="dot skelet"></div>
          <div className="line skelet"></div>
          <div className="dot skelet"></div>
        </div>
        <div className="status-text text skelet"></div>
      </td>
      <td className="td display-desktop-only">
        <div className="delivery-logo skelet"></div>
        <div className="delivery-text text skelet"></div>
      </td>
      <td className="td display-desktop-only">
        <div className="delivery-logo city skelet"></div>
        <div className="text region skelet"></div>
      </td>
      <td className="td display-desktop-only">
        <div className="delivery-logo skelet delivery-status"></div>
      </td>
      <td className="td display-desktop-only">
        <div className="delivery-logo skelet price"></div>
      </td>
    </Wrapper>
  );
};

export default OrdersSkeleton;
